import About_blc from './About_Blc/About_blc';
import Blc_Highlight from './Blc_Highlights/Blc_Highlight';
import Facilities_Services from './Facilities_Services/Facilities_Services';
import Hero_section from './Hero_Section/Hero_section'
import Blc_location from './Blc_location/Blc_location';
import Spotlight from './Blc_Spotlight/Spotlight';
import Blc_partner from './Blc_partner/Blc_partner';
import Blc_map from './Blc_map/Blc_map';
import { Helmet } from "react-helmet";


const HomeLanding = (props) => {
    //  console.log(props.valHighlights);
    const newsNumber = (valNum) => {
        // console.log(valNum);
        props.newsNum(valNum);
    }
    return (
        <div>
            <Helmet>
                <title>Best Learning Center for Your Organization | BRAC</title>
                <meta name="description" content="Brac Learning Centre is equipped to provide effective
workshops that offers overall resort and training solutions for all organizational
facilitation needs." />
                <meta name="keywords" content="BRAC, learning centre, learning centre near me, best learning
centre, learning centre for organization, corporate training, best corporate
training facilities, training, learning facilities, training venues, corporate
conference center" />
            </Helmet>
            <Hero_section heroVal={props.valHero} />
            <About_blc val={props.valAbout}></About_blc>
            <Facilities_Services val={props.valFacilities}></Facilities_Services>
            <Blc_Highlight val={props.valHighlights} newsNum={newsNumber} />
            <Blc_location val={props.valDifLocations}></Blc_location>
            <Spotlight val={props.valReservation}></Spotlight>
            <Blc_map />
            {/* <Blc_partner val={props.valPartner}></Blc_partner>  */}

        </div>
    )
}


export default HomeLanding;
